import React from "react";
import { motion } from "framer-motion";

const PHOTO =
  "https://customer-assets.emergentagent.com/job_transformo-invest/artifacts/exn4q8yb_jp.jpg";

export const FounderBadge = ({ className = "" }) => {
  const goToFounder = () => {
    const el = document.getElementById("founder");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.button
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      onClick={goToFounder}
      data-testid="founder-badge"
      aria-label="Meet the founder Jayaprakash Sahu"
      className={`group inline-flex items-center gap-3 rounded-full pl-1.5 pr-4 py-1.5 border border-brand-border bg-brand-surface/85 backdrop-blur hover:border-brand-accent/60 hover:bg-brand-elevated transition-all shadow-lg shadow-black/30 ${className}`}
    >
      <span className="relative inline-block">
        <img
          src={PHOTO}
          alt="Jayaprakash Sahu"
          className="w-11 h-11 rounded-full object-cover ring-2 ring-brand-accent/70 group-hover:ring-brand-accent transition-all"
          loading="eager"
        />
        <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full bg-brand-accent border-2 border-brand-surface" />
      </span>
      <span className="text-left leading-tight">
        <span className="block text-[10px] tracking-[0.22em] uppercase text-brand-accent">
          CEO · Investment Banker
        </span>
        <span className="block font-serif text-white text-sm md:text-base">
          Jayaprakash Sahu
        </span>
      </span>
    </motion.button>
  );
};

export default FounderBadge;
